/* BeatBot theme: beat player, beat search, license price */
(function () {
  'use strict';

  /* ---------- sticky beat player ---------- */
  var player = document.querySelector('[data-player]');
  var main = player && player.querySelector('[data-audio]');
  if (!player || !main) return;

  // The visualiser needs the audio file to allow cross-origin reading. If a file doesn't,
  // that beat plays through a plain second <audio> instead (the waveform then just idles).
  main.crossOrigin = 'anonymous';
  var plain = new Audio(); plain.preload = 'none';
  var audio = main;
  var ctx = null, analyser = null, noCors = {};
  function ensureGraph() {
    if (analyser || audio !== main) return;
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC();
      var srcNode = ctx.createMediaElementSource(main);
      analyser = ctx.createAnalyser();
      analyser.fftSize = 2048;
      analyser.smoothingTimeConstant = 0.78;
      srcNode.connect(analyser); analyser.connect(ctx.destination);
    } catch (e) { analyser = null; }
  }
  window.BeatBot = {
    analyser: function () { return (audio === main && !audio.paused) ? analyser : null; },
    playing: function () { return current && !audio.paused ? current.src : null; }
  };

  var $ = function (sel) { return player.querySelector(sel); };
  var fill = $('[data-fill]'), seek = $('[data-seek]'), cur = $('[data-p-cur]'), dur = $('[data-p-dur]');
  var titleEl = $('[data-p-title]'), coverImg = $('[data-p-cover]'), links = player.querySelectorAll('[data-p-link]');
  var current = null;          // {src, title, url, cover}
  var seeking = false;
  var KEY = 'beatbot-player';

  function fmt(s) {
    if (!isFinite(s) || s < 0) s = 0;
    var m = Math.floor(s / 60), r = Math.floor(s % 60);
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function beats() {
    var seen = {}, list = [];
    document.querySelectorAll('[data-beat]').forEach(function (el) {
      var src = el.getAttribute('data-src');
      if (!src || seen[src] || el.offsetParent === null && !el.closest('.cover-wrap')) return;
      seen[src] = 1;
      list.push(info(el));
    });
    return list;
  }

  function info(el) {
    return { src: el.getAttribute('data-src'), title: el.getAttribute('data-title'),
             url: el.getAttribute('data-url'), cover: el.getAttribute('data-cover') };
  }

  function save() {
    if (!current) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ b: current, t: audio.currentTime || 0, p: !audio.paused }));
    } catch (e) {}
  }

  function mark() {
    var playing = !audio.paused;
    player.classList.toggle('is-playing', playing);
    document.querySelectorAll('[data-beat]').forEach(function (el) {
      var on = current && el.getAttribute('data-src') === current.src;
      el.classList.toggle('playing', !!on);
      el.classList.toggle('is-playing', !!on && playing);
    });
  }

  function load(b, startAt) {
    current = b;
    try { audio.pause(); } catch (e) {}
    audio = noCors[b.src] ? plain : main;
    audio.src = b.src;
    if (startAt) {
      audio.addEventListener('loadedmetadata', function once() {
        audio.removeEventListener('loadedmetadata', once);
        try { audio.currentTime = startAt; } catch (e) {}
      });
    }
    titleEl.textContent = b.title || '';
    links.forEach(function (a) { a.href = b.url || '#'; });
    if (b.cover) { coverImg.src = b.cover; coverImg.hidden = false; coverImg.nextElementSibling.hidden = true; }
    else { coverImg.hidden = true; coverImg.nextElementSibling.hidden = false; }
    player.hidden = false;
    document.body.classList.add('has-player');
  }

  function play(b) {
    if (b && (!current || current.src !== b.src)) load(b);
    if (audio === main) { ensureGraph(); if (ctx && ctx.state === 'suspended') ctx.resume(); }
    var p = audio.play();
    if (p && p.catch) p.catch(function () { mark(); });
  }

  function toggle() { if (!current) return; audio.paused ? play() : audio.pause(); }

  function step(dir) {
    var list = beats();
    if (!list.length) return;
    var i = -1;
    list.forEach(function (b, k) { if (current && b.src === current.src) i = k; });
    var n = list[(i + dir + list.length) % list.length];
    play(n);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-play]');
    if (!btn) return;
    var el = btn.closest('[data-beat]');
    if (!el || !el.getAttribute('data-src')) return;
    e.preventDefault();
    var b = info(el);
    if (current && current.src === b.src) toggle(); else play(b);
  });

  $('[data-p-toggle]').addEventListener('click', toggle);
  $('[data-p-prev]').addEventListener('click', function () {
    if (audio.currentTime > 3) { audio.currentTime = 0; } else { step(-1); }
  });
  $('[data-p-next]').addEventListener('click', function () { step(1); });
  $('[data-p-close]').addEventListener('click', function () {
    audio.pause(); player.hidden = true; document.body.classList.remove('has-player');
    current = null; mark();
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  });

  seek.addEventListener('input', function () {
    seeking = true;
    if (audio.duration) {
      fill.style.width = (seek.value / 10) + '%';
      cur.textContent = fmt(audio.duration * seek.value / 1000);
    }
  });
  seek.addEventListener('change', function () {
    if (audio.duration) audio.currentTime = audio.duration * seek.value / 1000;
    seeking = false;
  });

  function bind(a) {
    a.addEventListener('play', mark);
    a.addEventListener('pause', function () { mark(); save(); });
    a.addEventListener('ended', function () { step(1); });
    a.addEventListener('loadedmetadata', function () { dur.textContent = fmt(audio.duration); });
    a.addEventListener('timeupdate', function () {
      var pct = audio.duration ? audio.currentTime / audio.duration * 100 : 0;
      if (!seeking) {
        fill.style.width = pct + '%';
        seek.value = Math.round(pct * 10);
        cur.textContent = fmt(audio.currentTime);
      }
      // the progress bar under the cover on a beat page
      document.querySelectorAll('.product-media').forEach(function (m) {
        var w = m.querySelector('[data-beat]'), f = m.querySelector('[data-status-fill]'), t = m.querySelector('[data-status-time]');
        if (!w || !f) return;
        var on = current && w.getAttribute('data-src') === current.src;
        f.style.width = (on ? pct : 0) + '%';
        if (t) t.textContent = on ? fmt(audio.currentTime) + ' / ' + fmt(audio.duration) : '0:00';
      });
    });
    a.addEventListener('error', function () {
      // this file won't allow the visualiser - replay it through the plain element
      if (a === main && current && main.src && !noCors[current.src]) {
        noCors[current.src] = 1;
        audio = plain; plain.src = current.src;
        var p = plain.play(); if (p && p.catch) p.catch(function () { mark(); });
      }
    });
  }
  bind(main); bind(plain);
  window.addEventListener('pagehide', save);

  // keep the beat going (paused where it was) when moving between pages
  try {
    var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && saved.b && saved.b.src) {
      load(saved.b, saved.t);
      cur.textContent = fmt(saved.t);
      if (saved.p) play();
      mark();
    }
  } catch (e) {}

  document.addEventListener('keydown', function (e) {
    if (e.code !== 'Space' || !current) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'button' || tag === 'select' || e.target.isContentEditable) return;
    e.preventDefault(); toggle();
  });
})();

(function () {
  'use strict';
  /* ---------- beat search box (filters the list as you type) ---------- */
  document.querySelectorAll('[data-beat-filter]').forEach(function (input) {
    var box = input.closest('.window');
    var list = box && box.querySelector('[data-beat-list]');
    var none = box && box.querySelector('[data-beat-none]');
    if (!list) return;
    input.addEventListener('input', function () {
      var terms = input.value.toLowerCase().split(/\s+/).filter(Boolean);
      var shown = 0;
      list.querySelectorAll('.beat-row').forEach(function (row) {
        var hay = row.getAttribute('data-search') || '';
        var ok = terms.every(function (t) { return hay.indexOf(t) !== -1; });
        row.hidden = !ok;
        if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
    });
  });

  /* ---------- license choice updates the button price ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var out = form.querySelector('[data-selected-price]');
    form.addEventListener('change', function (e) {
      if (e.target.name === 'id' && out) out.textContent = e.target.getAttribute('data-price');
    });
  });
})();
